<template>
  <a
    data-testid="studio-list-item"
    class="@container studioListItem tw-group tw-relative tw-flex tw-cursor-pointer tw-items-center tw-transition-all hover:tw-bg-slate-50"
    :class="{
      'tw-group tw-rounded tw-border-2 tw-border-deep-orange-600 tw-bg-slate-100': selected,
      'hover:dark:tw-bg-slate-900': !selected,
      '!tw-cursor-default': !clickable,
      'tw-pointer-events-none': disabled
    }"
    @click="e => $emit('click', e)"
  >
    <slot name="image-preview">
      <div v-if="!noImage" class="tw-w-40 tw-flex-none tw-self-center tw-overflow-hidden @sm:tw-block @sm:tw-w-28">
        <img
          v-if="imageSrc"
          :src="imageSrc"
          class="tw-mr-4 tw-aspect-video tw-w-full tw-max-w-[180px] tw-self-start tw-rounded-md tw-p-1"
          alt=""
          data-testid="studio-list-item-image"
        />
        <div v-else class="tw-p-1">
          <div
            class="tw-aspect-video tw-w-full tw-max-w-[180px] tw-self-start tw-rounded tw-bg-slate-100 tw-object-cover dark:tw-bg-slate-700"
          />
        </div>
      </div>
    </slot>

    <div class="tw-block tw-w-full tw-flex-1 tw-px-4">
      <slot name="badges" />
      <div class="tw-flex tw-items-center">
        <div
          class="tw-truncate tw-text-base tw-text-black @sm:tw-text-sm dark:tw-text-white"
          :class="{
            'dark:tw-text-black': selected,
            'tw-max-w-xs tw-truncate tw-text-ellipsis lg:tw-max-w-sm': truncateTitle
          }"
          data-testid="studio-list-item-title"
          :title="truncateTitle ? title : undefined"
        >
          {{ title }}
        </div>
        <slot name="info" />
      </div>

      <div
        class="ellipsisOneLine tw-text-xs tw-text-slate-500"
        data-testid="studio-list-item-subtitle"
        v-html="subTitle"
      />
      <slot name="body" />
    </div>

    <slot name="center" />
    <div class="tw-flex-none tw-pr-3 @lg:tw-pt-0">
      <slot name="right" />
    </div>
  </a>
</template>

<script lang="ts">
export default {
  name: 'StudioListItem',
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: ''
    },
    imageSrc: {
      type: String,
      default: null
    },
    noImage: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    truncateTitle: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.studioListItem .ellipsisOneLine {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
